// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import supportSelector from '../../../redux/selectors/support';
import { actionCreatorsList } from '../../../redux/rootActionCreator';
import { Support, SupportStateType, SupportType } from '../../../types/Model';

export function useDataSupportList(): Support[] {
  return useSelector(supportSelector.makeSupportListSelector());
}

export function useSupportListIsLoading(): boolean {
  return useSelector(supportSelector.makeSupportListIsLoading());
}

export function useSupportListError(): Error | undefined {
  return useSelector(supportSelector.makeSupportListError());
}

export function useGetSupportList(): () => void {
  const dispatch = useDispatch();
  return useCallback(() => {
    dispatch(actionCreatorsList.getSupportListActions.request({}))
  }, [])
}

export function useReplySupportData(): Support | {} {
  return useSelector(supportSelector.makeReplySupportSelector());
}

export function useReplySupportIsLoading(): boolean {
  return useSelector(supportSelector.makeReplySupportIsLoading());
}

export function useReplySupportError(): Error | undefined {
  return useSelector(supportSelector.makeReplySupportError());
}

export function useReplySupport(): (id: number, message: string, imagesFiles: File[]) => void {
  const dispatch = useDispatch();
  return useCallback((id, message, imagesFiles) => {
    dispatch(actionCreatorsList.replySupportActions.request({ id, message, imagesFiles }))
  }, [])
}

export function useUpdateReadSupportData(): boolean {
  return useSelector(supportSelector.makeUpdateReadSupportSelector());
}

export function useUpdateReadSupportIsLoading(): boolean {
  return useSelector(supportSelector.makeUpdateReadSupportIsLoading());
}

export function useUpdateReadSupportError(): Error | undefined {
  return useSelector(supportSelector.makeUpdateReadSupportError());
}

export function useUpdateReadSupport(): (id: number) => void {
  const dispatch = useDispatch();
  return useCallback((id) => {
    dispatch(actionCreatorsList.updateReadSupportActions.request({ id }))
  }, [])
}

export function useCreateNewSupportData(): Support | {} {
  return useSelector(supportSelector.makeCreateNewSupportSelector());
}

export function useCreateNewSupportIsLoading(): boolean {
  return useSelector(supportSelector.makeCreateNewSupportIsLoading());
}

export function useCreateNewSupportError(): Error | undefined {
  return useSelector(supportSelector.makeCreateNewSupportError());
}

export function useCreateNewSupport(): (message: string, imagesFiles: File[], title: string, supportType: SupportType) => void {
  const dispatch = useDispatch();
  return useCallback((message, imagesFiles, title, supportType) => {
    dispatch(actionCreatorsList.createNewSupportActions.request({ message, imagesFiles, title, supportType }))
  }, [])
}

export function useUpdateSupportStatusData(): SupportStateType {
  return useSelector(supportSelector.makeUpdateSupportStatusSelector());
}

export function useUpdateSupportStatusIsLoading(): boolean {
  return useSelector(supportSelector.makeUpdateSupportStatusIsLoading());
}

export function useUpdateSupportStatusError(): Error | undefined {
  return useSelector(supportSelector.makeUpdateSupportStatusError());
}

export function useUpdateSupportStatus(): (id: number) => void {
  const dispatch = useDispatch();
  return useCallback((id) => {
    dispatch(actionCreatorsList.updateSupportStatusActions.request({ id }))
  }, [])
}
